<style scoped lang="css"></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Checklists" />
        <div class="text-center" :class="loading ? 'mb-3' : ''">
          <b-spinner variant="light" type="grow" v-show="loading"></b-spinner>
        </div>
        <div v-show="!loading">
          <b-row class="mb-3">
            <b-col cols="6">
              <b-button-toolbar>
                <b-button variant="default" size="sm" @click="goBack">
                  <b-icon-chevron-left scale="1.3" />
                </b-button>
              </b-button-toolbar>
            </b-col>
            <b-col cols="6">
              <b-button-toolbar class="float-right">
                <b-button-group>
                  <b-button variant="primary" size="sm" @click="refresh">
                    <b-icon-arrow-clockwise scale="1.3" />
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-list-group class="mb-3" v-show="!loading">
            <b-list-group-item
              v-for="template in templates"
              :key="template.id"
              class="flex-column align-items-start"
            >
              <div class="d-flex justify-content-between">
                <h5 class="mb-1">{{ template.name }}</h5>
                <small>Revision: #{{ template.revision }}</small>
              </div>

              <div>
                <p>
                  Checklist contiene
                  {{ template.questions.length }} preguntas.
                </p>
                <small class="text-muted">
                  Creado hace {{ template.createdOn | timestamp }} y modificado
                  hace {{ template.lastUpdatedAt | timestamp }}
                </small>
              </div>
              <b-button-toolbar class="mt-1" justify>
                <b-button-group class="mr-1 mt-1">
                  <b-button
                    size="sm"
                    variant="info"
                    @click.stop="listEntries(template)"
                  >
                    Entradas
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    @click.stop="fillCheckList(template)"
                  >
                    Crear entrada
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-list-group-item>
          </b-list-group>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Header from "../Header";

moment.locale("es");

export default {
  name: "CheckLists",
  components: {
    Header,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    await this.fetchTemplates();
    this.loading = false;
  },
  computed: {
    ...mapGetters("templates", {
      templates: "getTemplates",
    }),
  },
  methods: {
    ...mapActions("templates", ["fetchTemplates"]),
    async refresh() {
      this.loading = true;
      try {
        await this.fetchTemplates();
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/");
    },
    fillCheckList(template) {
      this.$router.push(
        `/checklists/${template.id}/${template.revision}/entry`
      );
    },
    listEntries(template) {
      this.$router.push(`/checklists/${template.id}/entries`);
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).fromNow();
    },
  },
};
</script>
